import { ReactNode } from 'react';

import { TooltipIcon } from 'components/common/TooltipIcon/tooltipIcon';
import classes from 'components/common/WidgetWithCards/WidgetCard/WidgetFrame/WidgetFrame.module.scss';

interface Props {
    children: ReactNode | ReactNode[];
    titleComponents?: ReactNode[];
    title?: ReactNode;
    tooltip?: IToolTip;
    className?: string;
    id?: string;
}

export const WidgetFrame = ({ children, titleComponents, title = '', id, tooltip, className }: Props) => {
    return (
        <div data-testid={'widget-frame'} className={`${classes.WidgetFrame} ${className || ''} `} id={id}>
            <div className={classes.titleArea}>
                <div data-testid={'title-components'} className={classes.titleComponents}>
                    <h3 id={id ? `${id}_title` : undefined}>{title}</h3>
                    {(tooltip || titleComponents) && (
                        <div className={`${classes.endOfLine} `}>
                            {titleComponents && titleComponents?.map((child) => child)}
                            {tooltip && <TooltipIcon tooltip={tooltip} />}
                        </div>
                    )}
                </div>
            </div>
            <div data-testid={'area-content'} className={classes.contentArea}>
                {children}
            </div>
        </div>
    );
};
